// extracted by mini-css-extract-plugin
export default {"checkTypesWrapper":"CandidateIntroduction_checkTypesWrapper__imBT4","checkType":"CandidateIntroduction_checkType__7qdBY","logo":"CandidateIntroduction_logo__TPc+z"};